

















import { Component, Vue, Prop } from "vue-property-decorator";
import { DropdownOption } from "../../store/store.types";
import { Getter } from "vuex-class";
import { SITE_LANG } from "../../store/getters.names";
@Component({
  name: "DropdownField",
  components: {}
})
export default class DropdownField extends Vue {
  @Prop() label: string;
  @Prop() value: any;
  @Prop() options: DropdownOption[];
  @Getter(SITE_LANG) lang!: string;
  internalValue = this.value;

  emitData(e) {
    this.$emit("input", this.internalValue);
  }

  getLabel(opt: DropdownOption): string {
    return opt[`label_${this.lang}`] || opt["label"];
  }
}
